import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import reduceByKey from 'utils/reduceByKey'

interface State {
  proposals: Record<number, LaneProposal>
  meta: {
    isLoading: boolean
  }
}

const initialState: State = {
  proposals: {},
  meta: { isLoading: false },
}

export const slice = createSlice({
  name: 'laneProposals',
  initialState,
  reducers: {
    fetchLaneProposalsStart(state) {
      state.meta.isLoading = true
    },
    fetchLaneProposalsSuccess(state, action: PayloadAction<LaneProposal[]>) {
      state.proposals = reduceByKey(action.payload, 'id', {
        meta: { isUpdating: false, error: null },
      })
      state.meta.isLoading = false
    },
    fetchLaneProposalsFailed(state) {
      state.meta.isLoading = false
    },
    updateLaneProposalStart(state, action: PayloadAction<number>) {
      state.proposals[action.payload].meta = { isUpdating: true, error: null }
    },
    updateLaneProposalSuccess(state, action: PayloadAction<LaneProposal>) {
      const proposal = {
        ...state.proposals[action.payload.id],
        ...action.payload,
        meta: { isUpdating: false, error: null },
      }
      state.proposals[action.payload.id] = proposal
    },
    updateLaneProposalFailed(
      state,
      action: PayloadAction<{ id: number; error: string }>
    ) {
      state.proposals[action.payload.id].meta = {
        isUpdating: false,
        error: action.payload.error,
      }
    },
  },
})
export default slice.reducer
